import functionList from "./function/functionList";

/**
 * class FunctionRegister
 */
export default class FunctionRegister {
  /**
   * install
   * @param Vue
   */
  static install(Vue){
    //遍历FunctionRegister的方法给Vue实例添加方法
    console.log("FunctionRegister.install")
    for(let key in functionList){
      if(typeof functionList[key]==="function"){
        Vue.prototype[key]=functionList[key]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/FunctionRegister.js